import { MimeTypes } from '../enums/mime-types.enum';

export const MimeTypeMap = new Map([
  ['pdf', MimeTypes.PDF],
  ['jpg', MimeTypes.JPG],
  ['jpeg', MimeTypes.JPEG],
  ['png', MimeTypes.PNG],
]);

export const MimeTypeMapReverse = new Map<string, string>([
  ['image/jpeg', 'jpg'],
  ['image/png', 'png'],
  ['application/pdf', 'pdf'],
]);
